export const DIAGRAMS_DATA = {
    'carb-section': {
        title: 'Textbook Schematic: Marvel-Schebler MA-4SPA Section',
        src: 'diagrams/carb-section.png',
        hotspots: [
            // Left Column (Numbers/Text)
            { partId: 'carb-body', x: 2, y: 5, w: 10, h: 4, name: '1. Carburetor Body' },
            { partId: 'air-inlet', x: 2, y: 12, w: 10, h: 4, name: '2. Air Intake' },
            { partId: 'venturi', x: 2, y: 19, w: 10, h: 4, name: '3. Venturi' },
            { partId: 'throttle-valve', x: 2, y: 26, w: 10, h: 4, name: '4. Throttle Valve' },
            { partId: 'float-bowl', x: 2, y: 35, w: 10, h: 4, name: '5. Float Bowl' },
            { partId: 'float', x: 2, y: 44, w: 10, h: 4, name: '6. Metal Float' },
            { partId: 'needle-valve', x: 2, y: 51, w: 10, h: 4, name: '7. Needle Valve' },
            { partId: 'fuel-inlet', x: 2, y: 58, w: 10, h: 4, name: '8. Fuel Inlet Fitting' },
            { partId: 'main-discharge-nozzle', x: 2, y: 65, w: 10, h: 4, name: '9. Main Nozzle' },
            { partId: 'main-jet', x: 2, y: 72, w: 10, h: 4, name: '10. Main Metering Jet' },
            { partId: 'idle-port', x: 2, y: 80, w: 10, h: 4, name: '11. Idling System' },

            // Right Column (Numbers/Text)
            { partId: 'idle-mixture-screw', x: 75, y: 64, w: 10, h: 4, name: '12. Idle Mixture' },
            { partId: 'economizer', x: 75, y: 73, w: 10, h: 4, name: '13. Economizer System' },
            { partId: 'accel-pump', x: 75, y: 39, w: 10, h: 4, name: '14. Accel Pump' },
            { partId: 'mixture-control', x: 75, y: 26, w: 10, h: 4, name: '15. Mixture Control' },
            { partId: 'altitude-port', x: 75, y: 35, w: 10, h: 4, name: '16. Altitude Port' },
            { partId: 'main-air-bleed', x: 75, y: 49, w: 10, h: 4, name: '17. Air Bleeds' },
            { partId: 'throttle-stop-screw', x: 75, y: 19, w: 10, h: 4, name: '18. Throttle Stop' },
            { partId: 'gaskets', x: 75, y: 10, w: 10, h: 4, name: '19. Gaskets' },
            { partId: 'drain-plug', x: 75, y: 94, w: 10, h: 4, name: '20. Drain Plug' },

            // Central Image Hotspots (The actual carburetor drawing)
            { partId: 'venturi', x: 38, y: 38, w: 24, h: 10, name: 'Venturi Section' },
            { partId: 'throttle-valve', x: 44, y: 24, w: 12, h: 12, name: 'Throttle Valve' },
            { partId: 'float', x: 36, y: 53, w: 26, h: 12, name: 'Float Assembly' },
            { partId: 'float-bowl', x: 34, y: 52, w: 30, h: 22, name: 'Float Bowl' },
            { partId: 'main-discharge-nozzle', x: 46, y: 42, w: 8, h: 15, name: 'Main Discharge Nozzle' },
            { partId: 'needle-valve', x: 42, y: 62, w: 6, h: 10, name: 'Inlet Needle Valve' },
            { partId: 'accel-pump', x: 64, y: 35, w: 10, h: 20, name: 'Accelerator Pump' },
            { partId: 'mixture-control', x: 62, y: 20, w: 12, h: 15, name: 'Mixture Control Valve' },
            { partId: 'main-jet', x: 46, y: 70, w: 8, h: 8, name: 'Main Metering Jet' }
        ]
    },
    'fuel-system': {
        title: 'Pressure Type Fuel System Logic',
        src: 'diagrams/fuel-system-pressure.png',
        hotspots: [
            { partId: 'fuel-inlet', x: 50, y: 15, w: 10, h: 10, name: 'Carburetor Inlet' },
            { partId: 'fuel-pump', x: 50, y: 40, w: 15, h: 15, name: 'Engine Driven Pump' }
        ]
    },
    'fuel-detailed': {
        title: 'Pressure Type Fuel System (Selector Valve Detail)',
        src: 'diagrams/fuel-pressure-system-detail.png',
        hotspots: [
            { partId: 'carburetor', x: 45, y: 10, w: 15, h: 10, name: 'Main Carburetor' },
            { partId: 'electric-pump', x: 38, y: 28, w: 12, h: 18, name: 'Electric Pump (Plunger Type)' },
            { partId: 'engine-pump', x: 58, y: 28, w: 12, h: 18, name: 'Engine Driven Pump' },
            { partId: 'selector-valve', x: 45, y: 88, w: 12, h: 10, name: 'Fuel Selector Valve' },
            { partId: 'left-tank', x: 15, y: 88, w: 25, h: 10, name: 'Left Fuel Tank' },
            { partId: 'right-tank', x: 65, y: 88, w: 25, h: 10, name: 'Right Fuel Tank' },
            { partId: 'primer', x: 55, y: 65, w: 10, h: 10, name: 'Fuel Primer' }
        ]
    },
    'electric-pump': {
        title: 'Solenoid Type Electric Auxiliary Pump',
        src: 'diagrams/electric-pump.png',
        hotspots: [
            { partId: 'pump-strainer', x: 30, y: 75, w: 40, h: 10, name: 'Strainer' },
            { partId: 'pump-solenoid', x: 55, y: 40, w: 25, h: 40, name: 'Solenoid Coil' }
        ]
    }
};

// Wait, the coordinates above were based on pixels in my head, I should convert to % 
// Let's assume the diagram labels are on the left and right sides.
// I'll rewrite with percentages.

export const PART_TO_DIAGRAM = {
    'carb-body': 'carb-section',
    'air-inlet': 'carb-section',
    'venturi': 'carb-section',
    'throttle-valve': 'carb-section',
    'float-bowl': 'carb-section',
    'float': 'carb-section',
    'needle-valve': 'carb-section',
    'fuel-inlet': 'carb-section',
    'main-discharge-nozzle': 'carb-section',
    'main-jet': 'carb-section',
    'idle-port': 'carb-section',
    'idle-mixture-screw': 'carb-section',
    'economizer': 'carb-section',
    'accel-pump': 'carb-section',
    'mixture-control': 'carb-section',
    'altitude-port': 'carb-section',
    'main-air-bleed': 'carb-section',
    'throttle-stop-screw': 'carb-section',
    'gaskets': 'carb-section',
    'drain-plug': 'carb-section',
    'fuel-line': 'fuel-system'
};

